import { render } from "./MigrateAccountProjectResources.vue?vue&type=template&id=560a4264&scoped=true"
import script from "./MigrateAccountProjectResources.vue?vue&type=script&lang=js"
export * from "./MigrateAccountProjectResources.vue?vue&type=script&lang=js"

import "./MigrateAccountProjectResources.vue?vue&type=style&index=0&id=560a4264&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560a4264"]])

export default __exports__